import { compareVersions } from 'compare-versions';

function compareTgVersionNames(a: string, b: string): number {
  try {
    return compareVersions(a, b);
  } catch {
    return a.localeCompare(b);
  }
}

export function sortTgVersions<T extends { name: string }>(versions: readonly T[]): T[] {
  return [...versions].sort((a, b) => compareTgVersionNames(a.name, b.name));
}

export function defaultTgVersionName<T extends { name: string }>(versions: readonly T[]): string {
  const sorted = sortTgVersions(versions);
  return sorted.length > 0 ? sorted[sorted.length - 1].name : '';
}
